import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/features/marketing/content/content-page";
import { body } from "@/features/marketing/content/pages/timeline-6pm";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/wedding-day-timeline_/6pm-ceremony")({
  head: SEO["/wedding-day-timeline/6pm-ceremony"],
  component: () => <ContentPage path="/wedding-day-timeline/6pm-ceremony" body={body} />,
});
